module.exports = __webpack_public_path__ + "static/images/grid/background-frozen-columns.png";